module.exports = __webpack_public_path__ + "2531082406168707d2f2acf9ea1da102.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/smilies/4.png
// module id = 3624
// module chunks = 0